import { useState } from "react";
import { motion } from "framer-motion";
import { Loader2, Lock, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import { adminApi, setToken, formatApiErrorDetail } from "@/lib/adminApi";
import { navigate } from "@/lib/nav";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await adminApi.login(email, "");
      setToken(data.token);
      toast.success(`Welcome back, ${data.user.name}`);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain relative flex min-h-screen items-center justify-center bg-[#0B1320] px-5">
      <div className="pointer-events-none absolute inset-0 opacity-30" style={{ background: "radial-gradient(circle at 30% 20%, rgba(230,81,0,0.25), transparent 45%)" }} />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="glass relative z-10 w-full max-w-md rounded-3xl p-8 sm:p-10"
      >
        <div className="mb-8 flex flex-col items-center text-center">
          <Logo className="h-16 w-16" />
          <span className="data-label mt-4">Admin Portal</span>
          <h1 className="mt-1 font-display text-2xl font-bold uppercase text-white">Suryavansh Exim</h1>
          <p className="mt-1 text-sm text-slate-400">Enter your admin email to continue</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="data-label mb-1.5 block">Email</label>
            <input
              data-testid="admin-login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@suryavanshexim.com"
              className="w-full rounded-xl border border-white/10 bg-[#0B1320] px-4 py-3 text-sm text-white outline-none transition-colors focus:border-[#E65100]"
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="group flex w-full items-center justify-center gap-2 rounded-full bg-[#E65100] px-6 py-3.5 font-semibold text-white transition-all duration-300 hover:bg-[#FF6D00] hover:shadow-[0_0_30px_rgba(230,81,0,0.5)] disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Lock className="h-4 w-4" />}
            {loading ? "Signing in..." : "Sign In"}
            {!loading && <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />}
          </button>
        </form>

        <a href="/" className="mt-6 block text-center text-xs text-slate-500 transition-colors hover:text-[#D4AF37]">← Back to website</a>
      </motion.div>
    </div>
  );
}
